import MobileRecordCard from './MobileRecordCard';
import Badge from '@/components/base/Badge';
import { deliveryStatus } from '@/lib/statusDefs';

interface CustomerDeliveriesTabProps {
  deliveries: any[];
  sales?: any[];
}

function getDisplayStatus(delivery: any, sales: any[]): string {
  const matchingSale = sales.find((s: any) => s.id === delivery.sale_id);
  const saleStatus = matchingSale?.delivery_status;
  if (saleStatus === 'Teslim Edildi' && delivery.status !== 'Teslim Edildi') return 'Teslim Edildi';
  if (saleStatus === 'İptal' && delivery.status !== 'İptal') return 'İptal';
  return delivery.status;
}

export default function CustomerDeliveriesTab({ deliveries, sales = [] }: CustomerDeliveriesTabProps) {
  if (deliveries.length === 0) {
    return (
      <div className="p-5">
        <div className="flex flex-col items-center py-8 gap-2">
          <div className="w-12 h-12 rounded-2xl bg-background-100 flex items-center justify-center">
            <i className="ri-truck-line text-xl text-foreground-300"></i>
          </div>
          <p className="text-sm font-medium text-foreground-500">Henüz teslimat kaydı yok</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 lg:p-5">
      {/* Desktop table */}
      <div className="hidden lg:block overflow-x-auto">
        <table className="w-full min-w-[700px]">
          <thead><tr className="border-b border-background-100"><th className="table-header">Satış No</th><th className="table-header">Ürün</th><th className="table-header">Tarih</th><th className="table-header">Saat</th><th className="table-header">Personel</th><th className="table-header">Mahalle</th><th className="table-header">İlçe</th><th className="table-header">Durum</th></tr></thead>
          <tbody>
            {deliveries.map(delivery => {
              const displayStatus = getDisplayStatus(delivery, sales);
              return (
                <tr key={delivery.id} className="border-b border-background-100 hover:bg-background-50">
                  <td className="table-cell text-primary-600 font-medium">{delivery.sale_no}</td>
                  <td className="table-cell text-foreground-500">{delivery.product_name}</td>
                  <td className="table-cell">{delivery.delivery_date ? new Date(delivery.delivery_date).toLocaleDateString('tr-TR') : ''}</td>
                  <td className="table-cell text-foreground-500">{delivery.delivery_time}</td>
                  <td className="table-cell text-foreground-500">{delivery.delivery_person}</td>
                  <td className="table-cell text-foreground-400">{delivery.neighborhood || '—'}</td>
                  <td className="table-cell text-foreground-400">{delivery.district}</td>
                  <td className="table-cell py-2"><Badge badgeClass={deliveryStatus.badgeClass(displayStatus)} icon={deliveryStatus.icon(displayStatus)}>{displayStatus}</Badge></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Mobile cards */}
      <div className="lg:hidden space-y-2">
        {deliveries.map(delivery => {
          const displayStatus = getDisplayStatus(delivery, sales);
          return (
            <MobileRecordCard
              key={delivery.id}
              title={delivery.sale_no || '—'}
              subtitle={delivery.product_name}
              rows={[
                { label: 'Tarih', value: delivery.delivery_date ? new Date(delivery.delivery_date).toLocaleDateString('tr-TR') : '—' },
                ...(delivery.delivery_person ? [{ label: 'Personel', value: delivery.delivery_person }] : []),
                ...(delivery.neighborhood ? [{ label: 'Mahalle', value: delivery.neighborhood }] : []),
                ...(delivery.district ? [{ label: 'İlçe', value: delivery.district }] : []),
              ]}
              badges={[
                { text: displayStatus, className: deliveryStatus.badgeClass(displayStatus), icon: deliveryStatus.icon(displayStatus) },
              ]}
            />
          );
        })}
      </div>
    </div>
  );
}